# sizing iFrames in Company > Customize Careers Pages/Widget

$(->
  $('iframe.local').on 'load', (->
    if this.contentDocument?
      $(this).height(Math.max(this.contentDocument.documentElement.scrollHeight + 30, 250))
    else
      $(this).height(Math.max(this.contentWindow.document.body.scrollHeight + 30, 250))
  )
)
